export default function HomePage() {
  return (
    <a href="/recipe/06c2d0b7-dc08-428e-9c7f-19a9cc2acbf4/details">
      Sample Recipe
    </a>
  );
}
